import { CHANNELS, PLATFORMS, type Platform, type ReleaseChannel } from '@/lib/db';
import type { DownloadUrls } from '@/components/marketing/DownloadButton';
import type { Release } from '@/lib/releases';
import { formatDateMedium } from '@/lib/dates';

export function basenameFromUrl(url: string | null): string | null {
  if (!url) return null;
  try {
    const path = new URL(url).pathname;
    const last = path.split('/').pop();
    return last && last.length > 0 ? decodeURIComponent(last) : null;
  } catch {
    return null;
  }
}

export function buildUrls(release: Release): DownloadUrls {
  const out: DownloadUrls = {};
  if (release.windowsUrl) out.windows = release.windowsUrl;
  if (release.macosUrl) out.macos = release.macosUrl;
  return out;
}

export function formatReleasedAt(iso: string, locale: string): string {
  return formatDateMedium(iso, locale);
}

export function channelI18nKey(
  channel: ReleaseChannel,
): 'page.channel_beta' | 'page.channel_stable' {
  return channel === CHANNELS.beta ? 'page.channel_beta' : 'page.channel_stable';
}

export function verifyCommand(platform: Platform, fileName: string | null): string {
  const file =
    fileName ?? (platform === PLATFORMS.windows ? 'MeetBlast-Setup.exe' : 'MeetBlast.dmg');
  if (platform === PLATFORMS.windows) {
    return `Get-FileHash -Algorithm SHA256 ".\\${file}"`;
  }
  return `shasum -a 256 ~/Downloads/${file}`;
}
